@if(show$ | async) {
<div class="nova-flyout-shown">
    <div class="nova-flyout-title">{{ title }}</div>
    <div class="nova-flyout-title nova-flyout-subtitle">
        <a [routerLink]="fullListLink" class="nova__link">See Full Grid&nbsp;
            <img alt="go to grid" class="nova-flyout-subtitle-image" src="/assets/images/svg/open_in_new-24px.svg">
        </a>
    </div>
    <div class="nova-flyout-close-x" (click)="onCloseFlyoutClicked()">
        <img class="nova-flyout-close-x-image" alt="close" src="/assets/images/svg/clear-24px.svg" />
    </div>
    <p class="nova-flyout-divider">&nbsp;</p>
    <div class="nova-flyout-content">
        <ng-container [ngTemplateOutlet]="contentTemplate"></ng-container>
    </div>
</div>
}